import { inject, Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { Producer } from 'depoto-core/src/entities'
import { CoreService } from '../core.service'

@Injectable({ providedIn: 'root' }) // todo do i need this
export class ProducerService {
  private http = inject(HttpClient)
  core = inject(CoreService)

  public async getProducer(id, schema = { id: null, name: null }): Promise<Producer> {
    return new Producer(await this.core.services.producer.getById(id, schema))
  }

  async getProducers(
    parameters: any = { sort: 'name', direction: 'asc' },
    schema: any = { id: null, name: null }
  ): Promise<{
    items: Producer[]
    paginator: { current: null; endPage: null; totalCount: null }
  }> {
    return await this.core.services.producer.getList(parameters, schema)
  }

  createProducer(producer: Partial<Producer>, schema: Partial<Producer>): Promise<Producer> {
    return this.core.services.producer.create(producer, schema)
  }

  updateProducer(producer: Partial<Producer>, schema: Partial<Producer>): Promise<Producer> {
    return this.core.services.producer.update(producer, schema)
  }

  deleteProducer(producer: Partial<Producer>): Promise<Producer> {
    return this.core.services.producer.delete(producer)
  }
}
